<div *ngIf="messageBody?.length" class="alert alert-success message-block" [ngClass]="{
    'alert-success': messageTitle == 'Success',
    'alert-danger': messageTitle == 'Failed',
    'alert-info': messageTitle == 'Information'
  }">
    <button type="button" class="close-icon" (click)="closeMessage()">
        <span class="material-icons">close</span>
    </button>
    <strong>{{ messageTitle }}</strong>:
    <span class="mx-1">{{ messageBody }}</span>
</div>
<div>
    <div class="searchContainer" style="padding-top: 15px;">
        <div class="searchFields">
            <div *ngIf="user.IsMultiInstance && user.R_InstEnable_IV" class="searchBox2 searchItem">
                <div class="instanceContainer searchItem">
                    <label>Retain Instance</label>
                    <mat-form-field appearance="outline">
                        <div *ngIf="showInstanceLoader" class="loading-overlay">
                            <mat-spinner diameter="24"></mat-spinner>
                        </div>
                        <!-- <mat-spinner *ngIf="showInstanceLoader" [diameter]="15"></mat-spinner>
                         -->
                        <mat-select [(value)]="selectedInstance" (selectionChange)="onInstanceChange($event)"
                            placeholder="Retain instance">
                            <mat-option [value]="option.InstanceId" *ngFor="let option of instances">{{
                                option.InstanceName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="dateSearch searchItem">
                <label>Date range *</label>
                <form [formGroup]="range">
                    <mat-form-field appearance="outline">
                        <mat-date-range-input [rangePicker]="picker" [min]="startWith" [max]="endWith">
                            <input matStartDate formControlName="start" placeholder="Select Start Date"
                                (click)="picker.open()" (dateChange)="onReportStartDateChange($event)" readonly />-
                            <input matEndDate formControlName="end" placeholder="End Date" (click)="picker.open()"
                                (dateChange)="onReportEndDateChange($event)" readonly />
                        </mat-date-range-input>
                        <mat-icon (click)="resetfilter($event)">close</mat-icon>
                        <mat-date-range-picker (closed)="OnClosedDatePicker()" #picker></mat-date-range-picker>
                    </mat-form-field>
                    <div *ngIf="
                                                                                                                          range.get('start').value != null &&
                                                                                                                          (range.get('start').dirty || range.get('start').touched) &&
                                                                                                                          range.get('end').value === null &&
                                                                                                                          (range.get('end').dirty || range.get('end').touched)
                                                                                                                        "
                        class="alert alert-danger">
                        End date is required
                    </div>
                </form>
            </div>
            <div *ngIf="showWeekly" class="searchBox2 searchItem">
                <label>Weekly or Daily</label>
                <div class="expansionPreference searchItem">
                    <mat-radio-group aria-label="preferenceOption" class="expansionRadio" [(ngModel)]="weeklyModel"
                        (change)="WeelyOnChange($event)">
                        <mat-radio-button value="weekly" class="prefernceRadio">Weekly</mat-radio-button>
                        <mat-radio-button value="daily" class="prefernceRadio">Daily</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div *ngIf="showIncludeMERABookings" class="searchBox2 searchItem">
                <label>Include MERA Bookings</label>
                <div class="expansionPreference searchItem">
                    <mat-radio-group aria-label="preferenceOption" class="expansionRadio"
                        [(ngModel)]="includeMERABookingModel" (change)="IncludeMERABookingOnChange($event)">
                        <mat-radio-button value="yes" class="prefernceRadio">Yes</mat-radio-button>
                        <mat-radio-button value="no" class="prefernceRadio">No</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="showTabs" class="tab-container">
        <div *ngIf="showResourceTab" class="tab" (click)="selectTabVal('Resource')"
            [class.active]="selectedTabVal === 'Resource'">
            <span>Resource</span>
        </div>
        <div *ngIf="showEngagementTab" class="tab" (click)="selectTabVal('Engagement')"
            [class.active]="selectedTabVal === 'Engagement'">
            <span>Engagement</span>
        </div>
        <div *ngIf="showOtherTab" class="tab" (click)="selectTabVal('Other')"
            [class.active]="selectedTabVal === 'Other'">
            <span>Other</span>
        </div>
    </div>

    <div class="tab-content">
        <div *ngIf="selectedTabVal === 'Resource'">
            <div class="appLayout workRequest">
                <div class="requestedlog">
                    <!-- <div style="padding-bottom: 15px">
                        <span class="title">Filters Details</span>
                    </div> -->
                    <div class="infoSection2">


                        <!-- v1 -->


                        <div *ngIf="showResResource" appClickOutside (clickOutside)="closeDiv()">
                            <div class="countContainer">


                                <div class="searchContainer">
                                    <div class="searchFields">

                                        <div class="searchBox searchItem">
                                            <label>Resource</label>
                                            <div class="multselectionBox" *ngIf="selectedResItems.length > 0">
                                                <span *ngFor="let selectedItem of selectedResItems.slice(0, 2)">
                                                    <span style="padding-top: 2px; padding-left: 2px;"
                                                        class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                        <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                                (click)="onCloseSelectedResItems(selectedItem)">close</mat-icon>
                                                        </span>
                                                    </span>
                                                </span>
                                                <span *ngIf="selectedResItems.length > 2">
                                                    <span class="selectedItemCloseIcon"> + {{ selectedResItems.length -
                                                        2}}
                                                    </span>
                                                </span>
                                            </div>

                                            <mat-form-field class="resourceSearch" appearance="outline">
                                                <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                    (click)="loadResSelectedItem()" appSearchDebounce
                                                    (debounceKeyup)="search()" [(ngModel)]="searchBar" maxlength="75" />
                                                <mat-icon *ngIf="searchBar.trim().length > 0"
                                                    (click)="resetfilterResourceSearchBar()">close</mat-icon>
                                                <mat-icon *ngIf="searchBar.trim().length == 0"
                                                    (click)="loadResSelectedItem()">search</mat-icon>
                                            </mat-form-field>
                                            <!-- for Favourite   -- (click)="loadResSelectedItem()" <mat-icon>search</mat-icon> Engagement (click)="onFavEngagementSearch(item)"--- Start-->
                                            <div class="dropdown-list-wrap-res" *ngIf="showFavouriteResList">
                                                <mat-spinner *ngIf="showSearchLoader" [diameter]="30"></mat-spinner>
                                                <ul *ngIf="addFavouriteResResults?.length > 0"
                                                    class="dropdown-list tabdropdwn_actn">

                                                    <li *ngFor="let item of addFavouriteResResults"
                                                        class="dropdown-list-item" tabindex="0"
                                                        matTooltip="{{ item.Text }}">
                                                        <input type="checkbox" class="res-item-checkbox"
                                                            [value]="item.ID" (change)="onCheckboxChange($event, item)"
                                                            [checked]="isSelected(item)" />

                                                        <span class="EngFullname"> {{ item.Text }} </span>

                                                    </li>
                                                </ul>

                                            </div>
                                            <!-- for Favourite  Engagement --- End-->
                                            <div class="dropdown-list-wrap-res" style="padding-left: 2px;" *ngIf="
                                            showSearchLoader === false &&
                                            addFavouriteResResults?.length === 0 &&
                                            IsDataNotFound === true && 
                                            searchBar.trim().length > 0"> No Resource Found
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResAvailability" class="countContainer">
                            <label>Availability (%)</label>
                            <mat-form-field appearance="outline">
                                <input type="number" min="0" max="100" matInput [(ngModel)]="resAvailability">
                            </mat-form-field>
                        </div>
                        <div *ngIf="showResIncludeDummyResources" class="countContainer">
                            <label>Include Dummy Resources</label>
                            <div class="expansionPreference">
                                <mat-radio-group aria-label="preferenceOption" class="expansionRadio"
                                    [(ngModel)]="includeDummyResourcesModel"
                                    (change)="IncludeDummyResourcesOnChange($event)">
                                    <mat-radio-button value="yes" class="prefernceRadio">Yes</mat-radio-button>
                                    <mat-radio-button value="no" class="prefernceRadio">No</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div *ngIf="showResServiceLine" class="countContainer">

                            <label>Service Line</label>
                            <!-- [data]="resServiceLineLoader ? [] : resServiceLineList" -->
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Service Line'"
                                    [(ngModel)]="resServiceLineSelectedItems" [settings]="dropdownSettings"
                                    [data]="resServiceLineList" (onSelect)="changeSL()" (onDeSelect)="changeSL()">
                                </ng-multiselect-dropdown>

                                <div *ngIf="resServiceLineLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResSubServiceLine" class="countContainer">
                            <label>Sub Service Line</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Sub Service Line'"
                                    [(ngModel)]="resSubServiceLineSelectedItems" [settings]="dropdownSettings"
                                    [data]="resSubServiceLineList" (onSelect)="changeSSL()" (onDeSelect)="changeSSL()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resSubServiceLineLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="showResCompetency" class="countContainer">
                            <label>Competency</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Competency'" [(ngModel)]="resCompetencySelectedItems"
                                    [settings]="dropdownSettings" [data]="resCompetencyList" (onSelect)="changeResCompetency()"
                                    (onDeSelect)="changeResCompetency()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resCompetencyLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResCountry" class="countContainer">
                            <label>Country</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Country'" [settings]="dropdownSettings"
                                    [data]="resManageCountryList" [(ngModel)]="resManageCountrySelectedItems"
                                    (onSelect)="changeCountry()" (onDeSelect)="changeCountry()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resManageCountryLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResCostCenter" class="countContainer">
                            <label>Cost Center</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Cost Center'"
                                    [settings]="dropdownSettings" [data]="resViewCostCenterList"
                                    [(ngModel)]="resViewCostCenterSelectedItems" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>

                                <div *ngIf="resViewCostCenterLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResCompanyCode" class="countContainer">
                            <label>Company Code</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Company Code'"
                                    [(ngModel)]="resCompanyCodeSelectedItems" [settings]="dropdownSettings"
                                    [data]="resCompanyCodeList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>

                                <div *ngIf="resCompanyCodeLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="showResEconomicLocation" class="countContainer">
                            <label>Economic Location</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Economic Location'"
                                    [(ngModel)]="resEconomicLocationSelectedItems" [settings]="dropdownSettings"
                                    [data]="resEconomicLocationList" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resEconomicLocationLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResOfficeLocation" class="countContainer">
                            <label>Office Location</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Office Location'"
                                    [(ngModel)]="resOfficeLocationSelectedItems" [settings]="dropdownSettings"
                                    [data]="resOfficeLocationItems" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>

                                <div *ngIf="resOfficeLocationLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResLevel" class="countContainer">
                            <label>Level</label>
                            <ng-multiselect-dropdown [placeholder]="'Select Level'" [(ngModel)]="resLevelSelectedItems"
                                [settings]="dropdownSettings" [data]="resLevelList" (onSelect)="makeDirty()"
                                (onDeSelect)="makeDirty()">
                            </ng-multiselect-dropdown>
                            <div *ngIf="resLevelLoader" class="loading-overlay">
                                <mat-spinner diameter="24"></mat-spinner>
                            </div>
                        </div>
                        <div *ngIf="showResRank" class="countContainer">
                            <label>Rank</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Rank'"
                                    [(ngModel)]="resRankSelectedItems" [settings]="dropdownSettings"
                                    [data]="resRankList"   (onSelect)="changeRank()" (onDeSelect)="changeRank()"> 
                                    <!-- (onSelect)="makeDirty()" (onDeSelect)="makeDirty()"> -->
                                </ng-multiselect-dropdown>
                                <div *ngIf="resRankLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResGrade" class="countContainer">
                            <label>Grade</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Grade'"
                                    [(ngModel)]="resGradeSelectedItems" [settings]="dropdownSettings"
                                    [data]="resGradeList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resGradeLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResEmployeeStatus" class="countContainer">
                            <label>Employee Status</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Employee Status'"
                                    [(ngModel)]="resEmployeeStatusSelectedItems" [settings]="dropdownSettings"
                                    [data]="resEmployeeStatusList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resEmployeeStatusLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResEmployeeType" class="countContainer">
                            <label>Employee Type</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Employee Type'"
                                    [(ngModel)]="resEmployeeTypeSelectedItems" [settings]="dropdownSettings"
                                    [data]="resEmployeeTypeList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resEmployeeTypeLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <!-- <div *ngIf="showResEmployeeDepartment" class="countContainer">
                            <label>Employee Department</label> -->
                            <!-- <div class="multiselect-container"> vk
                                <ng-multiselect-dropdown [placeholder]="'Select Employee Department'"
                                    [(ngModel)]="resDepartmentSelectedItems" [settings]="dropdownSettings"
                                    [data]="resDepartmentList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resDepartmentLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div> -->
                        <!-- </div>

                    </div> -->
                    <div *ngIf="showResEmployeeDepartment" class="countContainer" appClickOutside
                        (clickOutside)="closeDivResEmployeeDepartment()">


                        <div class="searchContainer">
                            <div class="searchFields">

                                <div class="searchBox searchItem">
                                    <label>Employee Department</label>
                                    <div class="multselectionBox" *ngIf="selectedResEmployeeDepartmentItems.length > 0">
                                        <span
                                            *ngFor="let selectedItem of selectedResEmployeeDepartmentItems.slice(0, 2)">
                                            <span style="padding-top: 2px; padding-left: 2px;"
                                                class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                        (click)="onCloseResEmployeeDepartmentItems(selectedItem)">close</mat-icon>
                                                </span>
                                            </span>
                                        </span>
                                        <span *ngIf="selectedResEmployeeDepartmentItems.length > 2">
                                            <span class="selectedItemCloseIcon"> + {{
                                                selectedResEmployeeDepartmentItems.length - 2}}
                                            </span>
                                        </span>
                                    </div>

                                    <mat-form-field class="resourceSearch" appearance="outline">
                                        <input type="text" autocomplete="off" placeholder="Search..." matInput
                                            appSearchDebounce (debounceKeyup)="searchResEmployeeDepartment()"
                                            [(ngModel)]="searchBarResEmployeeDepartment"
                                            (click)="loadSelectedResEmployeeDepartmentItem()" maxlength="10" />
                                        <mat-icon *ngIf="searchBarResEmployeeDepartment.length > 0"
                                            (click)="resetfiltersearchBarResEmployeeDepartment()">close</mat-icon>
                                        <mat-icon *ngIf="searchBarResEmployeeDepartment.length == 0"
                                            (click)="loadSelectedResEmployeeDepartmentItem()">search</mat-icon>
                                    </mat-form-field>
                                    <div class="dropdown-list-wrap-res" *ngIf="showFavouriteResEmployeeDepartmentList">
                                        <mat-spinner *ngIf="showSearchResEmployeeDepartmentLoader"
                                            [diameter]="40"></mat-spinner>
                                        <ul *ngIf="addFavouritResEmployeeDepartmentResults?.length > 0"
                                            class="dropdown-list tabdropdwn_actn">

                                            <li *ngFor="let item of addFavouritResEmployeeDepartmentResults"
                                                class="dropdown-list-item" tabindex="0"
                                                matTooltip="{{ item.Text }}">
                                                <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                    (change)="onResEmployeeDepartmentCheckboxChange($event, item)"
                                                    [checked]="isResEmployeeDepartmentSelected(item)" />

                                                <span class="EngFullname"> {{ item.Text }} </span>

                                            </li>
                                        </ul>
                                        <div style="padding-left: 2px;" *ngIf="
                                                    showSearchResEmployeeDepartmentLoader === false &&
                                                    addFavouritResEmployeeDepartmentResults?.length === 0 &&
                                                    IsDataNotFound === true && searchBarResEmployeeDepartment.length > 0
                                                "> No Employee Department found
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                   
                        <div *ngIf="showResFSO" class="countContainer">
                            <label>FSO</label>
                            <div class="expansionPreference">
                                <mat-radio-group aria-label="preferenceOption" class="expansionRadio"
                                    [(ngModel)]="fsoModel" (change)="FSOOnChange($event)">
                                    <mat-radio-button value="yes" class="prefernceRadio">Yes</mat-radio-button>
                                    <mat-radio-button value="no" class="prefernceRadio">No</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div *ngIf="showResGDSRegionAlignment" class="countContainer">
                            <label>GDS Region Alignment</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select GDS Region Alignment'"
                                    [(ngModel)]="resGDSRegionAlignmentSelectedItems" [settings]="dropdownSettings"
                                    [data]="resGDSRegionAlignmentList" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resGDSRegionAlignmentLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResRegion" class="countContainer">
                            <label>Region</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Region'"
                                    [(ngModel)]="resRegionSelectedItems" [settings]="dropdownSettings"
                                    [data]="resRegionList" (onSelect)="changeResRegion()" (onDeSelect)="changeResRegion()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resRegionLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showResSubRegion" class="countContainer">
                            <label>Sub Region</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Sub Region'"
                                    [(ngModel)]="resSubRegionSelectedItems" [settings]="dropdownSettings"
                                    [data]="resSubRegionList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="resSubRegionLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <!-- v2 -->
                        <div *ngIf="showResCounsellor" appClickOutside (clickOutside)="closeDivCounsellor()">
                            <div class="countContainer">
                                <div class="searchContainer">
                                    <div class="searchFields">
                                        <div class="searchBox searchItem">
                                            <label>Counsellor</label>
                                            <div class="multselectionBox" *ngIf="selectedCounsellorItems.length > 0">
                                                <span *ngFor="let selectedItem of selectedCounsellorItems.slice(0, 2)">
                                                    <span style="padding-top: 2px; padding-left: 2px;"
                                                        class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                        <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                                (click)="onCloseCounsellorItems(selectedItem)">close</mat-icon>
                                                        </span>
                                                    </span>
                                                </span>
                                                <span *ngIf="selectedCounsellorItems.length > 2">
                                                    <span class="selectedItemCloseIcon"> + {{
                                                        selectedCounsellorItems.length - 2}}
                                                    </span>
                                                </span>
                                            </div>
                                            <mat-form-field class="resourceSearch" appearance="outline">
                                                <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                    appSearchDebounce (debounceKeyup)="searchCouncellor()"
                                                    (click)="loadCounsellorSelectedItem()"
                                                    [(ngModel)]="searchCouncellorBar" maxlength="75" />
                                                <mat-icon *ngIf="searchCouncellor.length > 0"
                                                    (click)="resetfilterCouncellorSearchBar()">close</mat-icon>
                                                <mat-icon *ngIf="searchCouncellor.length == 0"
                                                    (click)="loadCounsellorSelectedItem()">search</mat-icon>

                                            </mat-form-field>

                                            <!-- for Favourite   -- (click)="loadResSelectedItem()" <mat-icon>search</mat-icon> Engagement (click)="onFavEngagementSearch(item)"--- Start-->
                                            <div class="dropdown-list-wrap-res" *ngIf="showFavouriteCounsellorList">
                                                <mat-spinner *ngIf="showSearchCouncellorLoader"
                                                    [diameter]="40"></mat-spinner>
                                                <ul *ngIf="addFavouriteCounsellorResults?.length > 0"
                                                    class="dropdown-list tabdropdwn_actn">
                                                    <li *ngFor="let item of addFavouriteCounsellorResults"
                                                        class="dropdown-list-item" tabindex="0"
                                                        matTooltip="{{ item.Text }}">
                                                        <input type="checkbox" class="res-item-checkbox"
                                                            [value]="item.ID"
                                                            (change)="onCheckboxChangeCounsellor($event, item)"
                                                            [checked]="isSelectedCounsellor(item)" />

                                                        <span class="EngFullname"> {{ item.Text }} </span>

                                                    </li>
                                                </ul>
                                                <div class="dropdown-list-wrap-res" style="padding-left: 2px;" *ngIf="
                                                showSearchCouncellorLoader === false &&
                                                addFavouriteCounsellorResults?.length === 0 &&
                                                IsDataNotFound === true &&
                                                searchCouncellorBar.trim().length > 0">
                                                    No Counsellor Found
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="selectedTabVal === 'Engagement'">
            <div class="appLayout workRequest">
                <div class="requestedlog">
                    <!-- <div style="padding-bottom: 15px">
                        <span class="title">Filters Details</span>
                    </div> -->
                    <div class="infoSection2">
                        <!-- //v3 -->
                        <div *ngIf="showEngEngagement" appClickOutside (clickOutside)="closeDivEng()">

                            <div class="countContainer">
                                <div class="searchContainer">
                                    <div class="searchFields">
                                        <div class="searchBox searchItem">
                                            <label>Engagement</label>

                                            <div class="multselectionBox" *ngIf="selectedEngItems.length > 0">
                                                <span *ngFor="let selectedItem of selectedEngItems.slice(0, 2)">
                                                    <span style="padding-top: 2px; padding-left: 2px;"
                                                        class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                        <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                                (click)="onCloseEngItems(selectedItem)">close</mat-icon>
                                                        </span>
                                                    </span>
                                                </span>
                                                <span *ngIf="selectedEngItems.length > 2">
                                                    <span class="selectedItemCloseIcon"> + {{ selectedEngItems.length -
                                                        2}}
                                                    </span>
                                                </span>
                                            </div>
                                            <mat-form-field class="resourceSearch" appearance="outline">
                                                <input type="text" placeholder="Search..." matInput appSearchDebounce
                                                    (click)="loadEngSelectedItem()" (debounceKeyup)="searchEng()"
                                                    [(ngModel)]="engSearchBar" autocomplete="off" maxlength="200" />
                                                <!-- <mat-icon (click)="resetfilterEngagementSearchBar()">close</mat-icon> -->
                                                <mat-icon *ngIf="engSearchBar.length > 0"
                                                    (click)="resetfilterEngagementSearchBar()">close</mat-icon>
                                                <mat-icon *ngIf="engSearchBar.length == 0"
                                                    (click)="loadEngSelectedItem()">search</mat-icon>

                                            </mat-form-field>
                                            <div class="dropdown-list-wrap-res" *ngIf="showFavouriteEngList">
                                                <mat-spinner *ngIf="showEngSearchLoader" [diameter]="40"></mat-spinner>
                                                <ul *ngIf="addFavouriteEngResults?.length > 0"
                                                    class="dropdown-list tabdropdwn_actn">
                                                    <li *ngFor="let item of addFavouriteEngResults"
                                                        class="dropdown-list-item" tabindex="0"
                                                        matTooltip="{{ item.Text }}">
                                                        <input type="checkbox" class="res-item-checkbox"
                                                            [value]="item.ID"
                                                            (change)="onCheckboxChangeEng($event, item)"
                                                            [checked]="isSelectedEng(item)" />

                                                        <span class="EngFullname"> {{ item.Text }} </span>

                                                    </li>
                                                </ul>
                                                <div style="padding-left: 2px;" *ngIf="
                                                    showEngSearchLoader === false &&
                                                    addFavouriteEngResults?.length === 0 && 
                                                    engSearchBar.length > 0 &&
                                                    IsDataNotFound === true">
                                                    No Engagement Found
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngIncludeDummyEngagement" class="countContainer">
                            <label>Include Dummy Engagement</label>
                            <div class="expansionPreference searchItem">
                                <mat-radio-group aria-label="preferenceOption" class="expansionRadio"
                                    [(ngModel)]="includeDummyEngagementModel"
                                    (change)="IncludeDummyEngagementOnChange($event)">
                                    <mat-radio-button value="yes" class="prefernceRadio">Yes</mat-radio-button>
                                    <mat-radio-button value="no" class="prefernceRadio">No</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div *ngIf="showEngEngagementType" class="countContainer">
                            <label>Engagement Type</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Engagement Type'"
                                    [settings]="dropdownSettings" [data]="engagementTypes"
                                    [(ngModel)]="engEngagementTypesSelectedItems" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engagementTypesLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngEngagementSubType" class="countContainer">
                            <label>Engagement Sub Type</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Engagement Sub Type'"
                                    [settings]="dropdownSettings" [data]="engagementSubTypes"
                                    [(ngModel)]="engEngagementSubTypesSelectedItems" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engEngagementSubTypesLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngServiceLine" class="countContainer">
                            <label>Service Line</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Service Line'"
                                    [(ngModel)]="engServiceLineSelectedItems" [settings]="dropdownSettings"
                                    [data]="engServiceLineList" (onSelect)="changeEngSL()" (onDeSelect)="changeEngSL()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engServiceLineLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngSubServiceLine" class="countContainer">
                            <label>Sub Service Line</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Sub Service Line'"
                                    [(ngModel)]="engSubServiceLineSelectedItems" [settings]="dropdownSettings"
                                    [data]="engSubServiceLineList" (onSelect)="changeEngSSL()"
                                    (onDeSelect)="changeEngSSL()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engSubServiceLineLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngEngagementCompetency" class="countContainer">
                            <label>Engagement Competency</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Engagement Competency'"
                                    [(ngModel)]="engCompetencySelectedItems" [settings]="dropdownSettings"
                                    [data]="engCompetencyList"  (onSelect)="changeEngCompetency()"
                                    (onDeSelect)="changeEngCompetency()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engCompetencyLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngEngagementRegion" class="countContainer">
                            <label>Engagement Region</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Engagement Region'"
                                    [(ngModel)]="engRegionSelectedItems" [settings]="dropdownSettings"
                                    [data]="engRegionList" (onSelect)="changeEngRegion()"
                                    (onDeSelect)="changeEngRegion()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engRegionLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngEngagementCountry" class="countContainer">
                            <label>Engagement Country</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Engagement Country'"
                                    [settings]="dropdownSettings" [data]="engManageCountryList"
                                    [(ngModel)]="engManageCountrySelectedItems" (onSelect)="changeEngCountry()"
                                    (onDeSelect)="changeEngCountry()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engManageCountryLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="showEngEngagementCostCenter" class="countContainer">
                            <label>Engagement Cost Center</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Engagement Cost Center'"
                                    [(ngModel)]="engCostCenterSelectedItems" [settings]="dropdownSettings"
                                    [data]="engCostCenterList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engCostCenterLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngEngagementStatus" class="countContainer">
                            <label>Engagement Status</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Engagement Status'"
                                    [(ngModel)]="engJobStatusSelectedItems" [settings]="dropdownSettings"
                                    [data]="engJobStatusList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engJobStatusLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngCustomerIndustry" class="countContainer">
                            <label>Customer Industry</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Customer Industry'"
                                    [(ngModel)]="engCustomerIndustrySelectedItems" [settings]="dropdownSettings"
                                    [data]="engCustomerIndustryList" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engCustomerIndustryLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showEngCustomerPriorityStatus" class="countContainer">
                            <label>Customer Priority Status</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Customer Priority Status'"
                                    [(ngModel)]="engCustomerPriorityStatusSelectedItems" [settings]="dropdownSettings"
                                    [data]="engCustomerPriorityStatusList" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="engCustomerPriorityStatusLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <!-- v4 -->
                        <div *ngIf="showEngEngagementManager" class="countContainer" appClickOutside
                            (clickOutside)="closeDivEngManager()">
                            <div class="searchContainer">
                                <div class="searchFields">
                                    <div class="searchBox searchItem">
                                        <label>Engagement Manager</label>
                                        <div class="multselectionBox" *ngIf="selectedEngManagerItems.length > 0">
                                            <span *ngFor="let selectedItem of selectedEngManagerItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;">
                                                        <mat-icon
                                                            (click)="onCloseEngMangerItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedEngManagerItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{ selectedEngManagerItems.length
                                                    - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchEngManager()"
                                                (click)="loadEngManagerSelectedItem()" [(ngModel)]="searchEngManagerBar"
                                                maxlength="75" />

                                            <mat-icon *ngIf="searchEngManagerBar.length > 0"
                                                (click)="resetfilterEngManagerSearchBar()">close</mat-icon>
                                            <mat-icon *ngIf="searchEngManagerBar.length == 0"
                                                (click)="loadEngManagerSelectedItem()">search</mat-icon>
                                        </mat-form-field>
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteEngManagerList">
                                            <mat-spinner *ngIf="showSearchEngManagerLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouriteEngManagerResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">
                                                <li *ngFor="let item of addFavouriteEngManagerResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onCheckboxChangeEngManager($event, item)"
                                                        [checked]="isSelectedEngManager(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                            showSearchEngManagerLoader === false &&
                                            addFavouriteEngManagerResults?.length === 0 &&
                                            IsDataNotFound === true && searchEngManagerBar.length > 0
                                                ">
                                                No Engagement Manager Found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- v4 -->

                        <div *ngIf="showEngEngagementPartner" class="countContainer" appClickOutside
                            (clickOutside)="closeDivEngPartner()">
                            <div class="searchContainer">
                                <div class="searchFields">
                                    <div class="searchBox searchItem">
                                        <label>Engagement Partner</label>

                                        <div class="multselectionBox" *ngIf="selectedEngPartnerItems.length > 0">
                                            <span *ngFor="let selectedItem of selectedEngPartnerItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;">
                                                        <mat-icon
                                                            (click)="onCloseEngPartnerItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedEngPartnerItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{ selectedEngPartnerItems.length
                                                    - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchEngPartner()"
                                                (click)="loadEngPartnerSelectedItem()" [(ngModel)]="searchEngPartnerBar"
                                                maxlength="75" />

                                            <mat-icon *ngIf="searchEngPartnerBar.length > 0"
                                                (click)="resetfilterEngPartnerSearchBar()">close</mat-icon>
                                            <mat-icon *ngIf="searchEngPartnerBar.length == 0"
                                                (click)="loadEngPartnerSelectedItem()">search</mat-icon>

                                        </mat-form-field>
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteEngPartnerList">
                                            <mat-spinner *ngIf="showSearchEngPartnerLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouriteEngPartnerResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">
                                                <li *ngFor="let item of addFavouriteEngPartnerResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onCheckboxChangeEngPartner($event, item)"
                                                        [checked]="isSelectedEngPartner(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                            showSearchEngPartnerLoader === false &&
                                                    addFavouriteEngPartnerResults?.length === 0 &&
                                                    IsDataNotFound === true && searchEngPartnerBar.length > 0
                                                ">
                                                No Engagement Partner Found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- v5 -->
                        <div *ngIf="showEngCustomer" class="countContainer" appClickOutside
                            (clickOutside)="closeDivEngCustomer()">
                            <div class="searchContainer">
                                <div class="searchFields">
                                    <div class="searchBox searchItem">
                                        <label>Customer</label>

                                        <div class="multselectionBox" *ngIf="selectedEngCustomerItems.length > 0">
                                            <span *ngFor="let selectedItem of selectedEngPartnerItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;">
                                                        <mat-icon
                                                            (click)="onCloseEngCustomerItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedEngCustomerItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{
                                                    selectedEngCustomerItems.length - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchCustomer()"
                                                (click)="loadEngCustomerSelectedItem()" [(ngModel)]="searchCustomerBar"
                                                maxlength="75" />
                                            <mat-icon *ngIf="searchCustomerBar.length > 0"
                                                (click)="resetfilterSearchCustomerSearchBar()">close</mat-icon>
                                            <mat-icon *ngIf="searchCustomerBar.length == 0"
                                                (click)="loadEngCustomerSelectedItem()">search</mat-icon>
                                        </mat-form-field>
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteEngCustomerList">
                                            <mat-spinner *ngIf="showSearchCustomerLoader" [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouriteEngCustomerResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">
                                                <li *ngFor="let item of addFavouriteEngCustomerResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onCheckboxChangeEngCustomer($event, item)"
                                                        [checked]="isSelectedEngCustomer(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} - {{ item.Code }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                            showSearchCustomerLoader === false &&
                                            addFavouriteEngCustomerResults?.length === 0 &&
                                                    IsDataNotFound === true && searchCustomerBar.length > 0
                                                ">
                                                No Engagement Customer Found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- v6 -->
                        <div *ngIf="showEngUltCust" class="countContainer" appClickOutside
                            (clickOutside)="closeDivEngUltCust()">
                            <div class="searchContainer">
                                <div class="searchFields">
                                    <div class="searchBox searchItem">
                                        <label>Ultimate Customer</label>

                                        <div class="multselectionBox" *ngIf="selectedEngUltCustItems.length > 0">
                                            <span *ngFor="let selectedItem of selectedEngUltCustItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;">
                                                        <mat-icon
                                                            (click)="onCloseEngUltCustItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedEngUltCustItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{ selectedEngUltCustItems.length
                                                    - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchUtilmateCustomer()"
                                                (click)="loadEngUltCustSelectedItem()" [(ngModel)]="searchUltCustBar"
                                                maxlength="75" />

                                            <mat-icon *ngIf="searchUltCustBar.length > 0"
                                                (click)="resetfilterSearchUltCustSearchBar()">close</mat-icon>
                                            <mat-icon *ngIf="searchUltCustBar.length == 0"
                                                (click)="loadEngUltCustSelectedItem()">search</mat-icon>
                                        </mat-form-field>
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteEngUltCustList">
                                            <mat-spinner *ngIf="showSearchUltCustLoader" [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouriteEngUltCustResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">
                                                <li *ngFor="let item of addFavouriteEngUltCustResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onCheckboxChangeEngUltCust($event, item)"
                                                        [checked]="isSelectedEngUltCust(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} - {{ item.Code }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                            showSearchUltCustLoader === false &&
                                            addFavouriteEngUltCustResults?.length === 0 &&
                                                    IsDataNotFound === true && searchUltCustBar.length > 0
                                                ">
                                                No Ultimate Customer Found
                                            </div>
                                        </div>
                                        <!-- <div class="dropdown-list-wrap" *ngIf="showSearchUltimateCustomerList">
                                            <mat-spinner *ngIf="showSearchUltimateCustomerLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="ultimateCustomerResults?.length > 0"
                                                class="dropdown-list tabdropdwn">
                                                <li *ngFor="let item of ultimateCustomerResults"
                                                    (click)="OnUltimateCustomerSelect(item)"
                                                    (keyup.enter)="OnUltimateCustomerSelect(item)"
                                                    class="dropdown-list-item" tabindex="0">
                                                    {{ item.DisplayName }}
                                                </li>
                                            </ul>
                                            <div
                                                *ngIf="showSearchUltimateCustomerLoader === false && ultimateCustomerResults.length === 0">
                                                No Ultimate Customer Found
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="selectedTabVal === 'Other'">
            <div class="appLayout workRequest">
                <div class="requestedlog">
                    <!-- <div style="padding-bottom: 15px">
                        <span class="title">Filters Details</span>
                    </div> -->
                    <div class="infoSection2">
                        <div *ngIf="showOthBookingCategory" class="countContainer">
                            <label>Booking Category</label>
                            <ng-multiselect-dropdown [placeholder]="'Select Booking Category'"
                                [(ngModel)]="othBookingCategorySelectedItems" [settings]="dropdownSettings"
                                [data]="othBookingCategoryList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                            </ng-multiselect-dropdown>
                            <!-- <div *ngIf="othBookingCategoryLoader" class="loading-overlay">
                                <mat-spinner diameter="24"></mat-spinner>
                            </div> -->
                        </div>
                        <div *ngIf="showOtherBookingTypes" class="countContainer">
                            <label>Booking Type</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Booking Type'"
                                    [(ngModel)]="othBookingTypeSelectedItems" [settings]="dropdownSettings"
                                    [data]="othBookingTypeList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="othBookingTypeLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showOtherMERAActions" class="countContainer">
                            <label>MERA Action</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select MERA Action'"
                                    [(ngModel)]="othMERAActionSelectedItems" [settings]="dropdownSettings"
                                    [data]="othMERAActionList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="othMERAActionLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showOtherRequestorModes" class="countContainer">
                            <label>Request Mode</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Request Mode'"
                                    [(ngModel)]="othMeraRequestModeSelectedItems" [settings]="dropdownSettings"
                                    [data]="othMeraRequestModeList" (onSelect)="makeDirty()" (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="othMeraRequestModeLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showOtherStatus" class="countContainer">
                            <label>Status</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Status'"
                                    [(ngModel)]="othMeraBookingStatusSelectedItems" [settings]="dropdownSettings"
                                    [data]="othMeraBookingStatusList" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="othMeraBookingStatusLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showOtherStatusInformation" class="countContainer">
                            <label>Status Information</label>
                            <div class="multiselect-container">
                                <ng-multiselect-dropdown [placeholder]="'Select Status Information'"
                                    [(ngModel)]="othMeraStatusInformationSelectedItems" [settings]="dropdownSettings"
                                    [data]="othMeraStatusInformationList" (onSelect)="makeDirty()"
                                    (onDeSelect)="makeDirty()">
                                </ng-multiselect-dropdown>
                                <div *ngIf="othMeraStatusInformationLoader" class="loading-overlay">
                                    <mat-spinner diameter="24"></mat-spinner>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="showOtherBookings" class="countContainer" appClickOutside
                            (clickOutside)="closeDivOtherRetainBookingId()">
                            <div class="searchContainer">
                                <div class="searchFields">
                                    <div class="searchBox searchItem">
                                        <label>Retain Booking Id</label>
                                        <div class="multselectionBox" *ngIf="selectedOthBookingItems.length > 0">
                                            <span *ngFor="let selectedItem of selectedOthBookingItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{
                                                    selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;">
                                                        <mat-icon
                                                            (click)="onCloseOtherRetainBookingIdItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedOthBookingItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{
                                                    selectedOthBookingItems.length - 2}}
                                                </span>
                                            </span>
                                        </div>
                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="number" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchOthBookingId()"
                                                [(ngModel)]="searchBarOthBookingId"
                                                (click)="loadSelectedOthBookingIdItem()" maxlength="10" />
                                            <mat-icon *ngIf="searchBarOthBookingId.length > 0"
                                                (click)="resetfiltersearchBarOthBookingId()">close</mat-icon>
                                            <mat-icon *ngIf="searchBarOthBookingId.length == 0"
                                                (click)="loadSelectedOthBookingIdItem()">search</mat-icon>
                                        </mat-form-field>
                                        <!-- for Favourite   -- (click)="loadResSelectedItem()" <mat-icon>search</mat-icon> Engagement (click)="onFavEngagementSearch(item)"--- Start-->
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteOthBookingList">
                                            <mat-spinner *ngIf="showSearchOthBookingLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouriteOthBookingIdResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">

                                                <li *ngFor="let item of addFavouriteOthBookingIdResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onOtherBookingsCheckboxChange($event, item)"
                                                        [checked]="isOtherBookingsSelected(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                                    showSearchOthBookingLoader === false &&
                                                    addFavouriteOthBookingIdResults?.length === 0 &&
                                                    IsDataNotFound === true && searchBarOthBookingId.length > 0
                                                "> No Booking Id found
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div *ngIf="showOtherMERABookings" class="countContainer" appClickOutside
                            (clickOutside)="closeDivOtherMERABookings()">


                            <div class="searchContainer">
                                <div class="searchFields">

                                    <div class="searchBox searchItem">
                                        <label>MERA Booking Id</label>
                                        <div class="multselectionBox" *ngIf="selectedOthMERABookingIdItems.length > 0">
                                            <span
                                                *ngFor="let selectedItem of selectedOthMERABookingIdItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                            (click)="onCloseOtherMERABookingIdItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedOthMERABookingIdItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{
                                                    selectedOthMERABookingIdItems.length - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="number" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchOthMERABookingId()"
                                                [(ngModel)]="searchBarOthMERABookingId"
                                                (click)="loadSelectedOthMERABookingIdItem()" maxlength="10" />
                                            <mat-icon *ngIf="searchBarOthMERABookingId.length > 0"
                                                (click)="resetfiltersearchBarOthMERABookingId()">close</mat-icon>
                                            <mat-icon *ngIf="searchBarOthMERABookingId.length == 0"
                                                (click)="loadSelectedOthMERABookingIdItem()">search</mat-icon>
                                        </mat-form-field>

                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteOthMERABookingIdList">
                                            <mat-spinner *ngIf="showSearchOthMERABookingIdLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouriteOthMERABookingIdResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">

                                                <li *ngFor="let item of addFavouriteOthMERABookingIdResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onOtherMERABookingsCheckboxChange($event, item)"
                                                        [checked]="isOtherMERABookingsSelected(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                                        showSearchOthMERABookingIdLoader === false &&
                                                        addFavouriteOthMERABookingIdResults?.length === 0 &&
                                                        IsDataNotFound === true && searchBarOthMERABookingId.length > 0
                                                    "> No MERA Booking Id found
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div *ngIf="showOtherRequestors" class="countContainer" appClickOutside
                            (clickOutside)="closeDivOtherRequestorName()">


                            <div class="searchContainer">
                                <div class="searchFields">

                                    <div class="searchBox searchItem">
                                        <label>Requestor Name</label>
                                        <div class="multselectionBox" *ngIf="selectedOthRequestorNameItems.length > 0">
                                            <span
                                                *ngFor="let selectedItem of selectedOthRequestorNameItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                            (click)="onCloseOtherRequestorNameItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedOthRequestorNameItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{
                                                    selectedOthRequestorNameItems.length - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchOthRequestorName()"
                                                [(ngModel)]="searchBarOthRequestorName"
                                                (click)="loadSelectedOthRequestorNameItem()" maxlength="10" />
                                            <mat-icon *ngIf="searchBarOthRequestorName.length > 0"
                                                (click)="resetfiltersearchBarOthRequestorName()">close</mat-icon>
                                            <mat-icon *ngIf="searchBarOthRequestorName.length == 0"
                                                (click)="loadSelectedOthRequestorNameItem()">search</mat-icon>
                                        </mat-form-field>
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteOthRequestorNameList">
                                            <mat-spinner *ngIf="showSearchOthRequestorNameLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouritOthRequestorNameResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">

                                                <li *ngFor="let item of addFavouritOthRequestorNameResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onOtherRequestorNameCheckboxChange($event, item)"
                                                        [checked]="isOtherRequestorNameSelected(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                                        showSearchOthRequestorNameLoader === false &&
                                                        addFavouritOthRequestorNameResults?.length === 0 &&
                                                        IsDataNotFound === true && searchBarOthRequestorName.length > 0
                                                    "> No Requestor Name found
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div *ngIf="showOtherSubmittedBy" class="countContainer" appClickOutside
                            (clickOutside)="closeDivOtherSubmittedby()">


                            <div class="searchContainer">
                                <div class="searchFields">

                                    <div class="searchBox searchItem">
                                        <label>Submitted By</label>
                                        <div class="multselectionBox" *ngIf="selectedOthSubmittedbyItems.length > 0">
                                            <span *ngFor="let selectedItem of selectedOthSubmittedbyItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                            (click)="onCloseOtherSubmittedbyItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedOthSubmittedbyItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{
                                                    selectedOthSubmittedbyItems.length - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchOthSubmittedby()"
                                                [(ngModel)]="searchBarOthSubmittedby"
                                                (click)="loadSelectedOthSubmittedbyItem()" maxlength="10" />
                                            <mat-icon *ngIf="searchBarOthSubmittedby.length > 0"
                                                (click)="resetfiltersearchBarOthSubmittedby()">close</mat-icon>
                                            <mat-icon *ngIf="searchBarOthSubmittedby.length == 0"
                                                (click)="loadSelectedOthSubmittedbyItem()">search</mat-icon>
                                        </mat-form-field>
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteOthSubmittedbyList">
                                            <mat-spinner *ngIf="showSearchOthSubmittedbyLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouritOthSubmittedbyResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">

                                                <li *ngFor="let item of addFavouritOthSubmittedbyResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onOtherSubmittedbyCheckboxChange($event, item)"
                                                        [checked]="isOtherSubmittedbySelected(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                                        showSearchOthSubmittedbyLoader === false &&
                                                        addFavouritOthSubmittedbyResults?.length === 0 &&
                                                        IsDataNotFound === true && searchBarOthSubmittedby.length > 0
                                                    "> No Submitted By found
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showOtherSubmittedOn" class="countContainer">
                            <label>Submitted On</label>
                            <form [formGroup]="submittedOnrange">
                                <mat-form-field appearance="outline" class="dateFilters">
                                    <mat-date-range-input [rangePicker]="submittedonpicker" [min]="submittedonstartWith"
                                        [max]="submittedonendWith">
                                        <input matStartDate formControlName="start" placeholder="Select Start Date"
                                            (click)="submittedonpicker.open()"
                                            (dateChange)="onSubmittedOnReportStartDateChange($event)" readonly />-
                                        <input matEndDate formControlName="end" placeholder="End Date"
                                            (click)="submittedonpicker.open()"
                                            (dateChange)="onSubmittedOnReportEndDateChange($event)" readonly />
                                    </mat-date-range-input>
                                    <mat-icon (click)="resetSubmittedOnfilter($event)">close</mat-icon>
                                    <mat-date-range-picker (closed)="OnSubmittedOnClosedDatePicker()"
                                        #submittedonpicker></mat-date-range-picker>
                                </mat-form-field>
                                <div *ngIf="
                                                        submittedOnrange.get('start').value != null &&
                                                                                                                                                              (submittedOnrange.get('start').dirty || submittedOnrange.get('start').touched) &&
                                                                                                                                                              submittedOnrange.get('end').value === null &&
                                                                                                                                                              (submittedOnrange.get('end').dirty || submittedOnrange.get('end').touched)
                                                                                                                                                            "
                                    class="alert alert-danger">
                                    End date is required
                                </div>
                            </form>
                        </div>
                        <div *ngIf="showOtherApprovedBy" class="countContainer" appClickOutside
                            (clickOutside)="closeDivOtherApprovedby()">


                            <div class="searchContainer">
                                <div class="searchFields">

                                    <div class="searchBox searchItem">
                                        <label>Approved By</label>
                                        <div class="multselectionBox" *ngIf="selectedOthApprovedbyItems.length > 0">
                                            <span *ngFor="let selectedItem of selectedOthApprovedbyItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                            (click)="onCloseOtherApprovedbyItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedOthApprovedbyItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{
                                                    selectedOthApprovedbyItems.length - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchOthApprovedby()"
                                                [(ngModel)]="searchBarOthApprovedby"
                                                (click)="loadSelectedOthApprovedbyItem()" maxlength="10" />
                                            <mat-icon *ngIf="searchBarOthApprovedby.length > 0"
                                                (click)="resetfiltersearchBarOthApprovedby()">close</mat-icon>
                                            <mat-icon *ngIf="searchBarOthApprovedby.length == 0"
                                                (click)="loadSelectedOthApprovedbyItem()">search</mat-icon>
                                        </mat-form-field>
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteOthApprovedbyList">
                                            <mat-spinner *ngIf="showSearchOthApprovedbyLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouritOthApprovedbyResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">

                                                <li *ngFor="let item of addFavouritOthApprovedbyResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onOtherApprovedbyCheckboxChange($event, item)"
                                                        [checked]="isOtherApprovedbySelected(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                                        showSearchOthApprovedbyLoader === false &&
                                                        addFavouritOthApprovedbyResults?.length === 0 &&
                                                        IsDataNotFound === true && searchBarOthApprovedby.length > 0
                                                    "> No Approved By found
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showOtherApprovedOn" class="countContainer">
                            <label>Approved On</label>
                            <form [formGroup]="approvedOnrange">
                                <mat-form-field appearance="outline">
                                    <mat-date-range-input [rangePicker]="approvedonpicker" [min]="approvedonstartWith"
                                        [max]="approvedonendWith">
                                        <input matStartDate formControlName="start" placeholder="Select Start Date"
                                            (click)="approvedonpicker.open()"
                                            (dateChange)="onApprovedOnReportStartDateChange($event)" readonly />-
                                        <input matEndDate formControlName="end" placeholder="End Date"
                                            (click)="approvedonpicker.open()"
                                            (dateChange)="onApprovedOnReportEndDateChange($event)" readonly />
                                    </mat-date-range-input>
                                    <mat-icon (click)="resetApprovedOnfilter($event)">close</mat-icon>
                                    <mat-date-range-picker (closed)="OnApprovedOnClosedDatePicker()"
                                        #approvedonpicker></mat-date-range-picker>
                                </mat-form-field>
                                <div *ngIf="
                                approvedOnrange.get('start').value != null &&
                                                                                                                                                              (approvedOnrange.get('start').dirty || approvedOnrange.get('start').touched) &&
                                                                                                                                                              approvedOnrange.get('end').value === null &&
                                                                                                                                                              (approvedOnrange.get('end').dirty || approvedOnrange.get('end').touched)
                                                                                                                                                            "
                                    class="alert alert-danger">
                                    End date is required
                                </div>
                            </form>
                        </div>

                        <div *ngIf="showOtherRejectedBy" class="countContainer" appClickOutside
                            (clickOutside)="closeDivOtherRejectedby()">


                            <div class="searchContainer">
                                <div class="searchFields">

                                    <div class="searchBox searchItem">
                                        <label>Rejected By</label>
                                        <div class="multselectionBox" *ngIf="selectedOthRejectedbyItems.length > 0">
                                            <span *ngFor="let selectedItem of selectedOthRejectedbyItems.slice(0, 2)">
                                                <span style="padding-top: 2px; padding-left: 2px;"
                                                    class="textboxlabel inline-list"> {{ selectedItem.Text }}
                                                    <span style="margin-left:5px; margin-top:2px;"> <mat-icon
                                                            (click)="onCloseOtherRejectedbyItems(selectedItem)">close</mat-icon>
                                                    </span>
                                                </span>
                                            </span>
                                            <span *ngIf="selectedOthRejectedbyItems.length > 2">
                                                <span class="selectedItemCloseIcon"> + {{
                                                    selectedOthRejectedbyItems.length - 2}}
                                                </span>
                                            </span>
                                        </div>

                                        <mat-form-field class="resourceSearch" appearance="outline">
                                            <input type="text" autocomplete="off" placeholder="Search..." matInput
                                                appSearchDebounce (debounceKeyup)="searchOthRejectedby()"
                                                [(ngModel)]="searchBarOthRejectedby"
                                                (click)="loadSelectedOthRejectedbyItem()" maxlength="10" />
                                            <mat-icon *ngIf="searchBarOthRejectedby.length > 0"
                                                (click)="resetfiltersearchBarOthRejectedby()">close</mat-icon>
                                            <mat-icon *ngIf="searchBarOthRejectedby.length == 0"
                                                (click)="loadSelectedOthRejectedbyItem()">search</mat-icon>
                                        </mat-form-field>
                                        <div class="dropdown-list-wrap-res" *ngIf="showFavouriteOthRejectedbyList">
                                            <mat-spinner *ngIf="showSearchOthRejectedbyLoader"
                                                [diameter]="40"></mat-spinner>
                                            <ul *ngIf="addFavouritOthRejectedbyResults?.length > 0"
                                                class="dropdown-list tabdropdwn_actn">

                                                <li *ngFor="let item of addFavouritOthRejectedbyResults"
                                                    class="dropdown-list-item" tabindex="0"
                                                    matTooltip="{{ item.Text }}">
                                                    <input type="checkbox" class="res-item-checkbox" [value]="item.ID"
                                                        (change)="onOtherRejectedbyCheckboxChange($event, item)"
                                                        [checked]="isOtherRejectedbySelected(item)" />

                                                    <span class="EngFullname"> {{ item.Text }} </span>

                                                </li>
                                            </ul>
                                            <div style="padding-left: 2px;" *ngIf="
                                                        showSearchOthRejectedbyLoader === false &&
                                                        addFavouritOthRejectedbyResults?.length === 0 &&
                                                        IsDataNotFound === true && searchBarOthRejectedby.length > 0
                                                    "> No Rejected By found
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="showOtherRejectedOn" class="countContainer">
                            <label>Rejected On</label>
                            <form [formGroup]="rejectedOnrange">
                                <mat-form-field appearance="outline">
                                    <mat-date-range-input [rangePicker]="rejectedonpicker" [min]="rejectedonstartWith"
                                        [max]="rejectedonendWith">
                                        <input matStartDate formControlName="start" placeholder="Select Start Date"
                                            (click)="rejectedonpicker.open()"
                                            (dateChange)="onRejectedOnReportStartDateChange($event)" readonly />-
                                        <input matEndDate formControlName="end" placeholder="End Date"
                                            (click)="rejectedonpicker.open()"
                                            (dateChange)="onRejectedOnReportEndDateChange($event)" readonly />
                                    </mat-date-range-input>
                                    <mat-icon (click)="resetRejectedOnfilter($event)">close</mat-icon>
                                    <mat-date-range-picker (closed)="OnRejectedOnClosedDatePicker()"
                                        #rejectedonpicker></mat-date-range-picker>
                                </mat-form-field>
                                <div *ngIf="
                                rejectedOnrange.get('start').value != null &&
                                                                                                                                                              (rejectedOnrange.get('start').dirty || rejectedOnrange.get('start').touched) &&
                                                                                                                                                              rejectedOnrange.get('end').value === null &&
                                                                                                                                                              (rejectedOnrange.get('end').dirty || rejectedOnrange.get('end').touched)
                                                                                                                                                            "
                                    class="alert alert-danger">
                                    End date is required
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="buttonSection">
    <div class="clearSection" matTooltip="Clear Selection" (click)="clearSelection()">
        Clear Selection
    </div>
    <div class="buttonPadding">
    </div>
    <div class="saveFilterButton" matTooltip="Save Filter" (click)="openModal()">
        Save Filter
    </div>
    <div class="buttonPadding">
    </div>
    <div class="generateReportButton" matTooltip="Generate Report" (click)="generateReport()">
        Generate Report
    </div>
    <div class="buttonPadding">
    </div>
    <div>
        <mat-checkbox (change)="makeDirty()" [(ngModel)]="isEmailRequired"
            [ngModelOptions]="{ standalone: true }">Email ?</mat-checkbox>
    </div>
</div>
<ng-template style="z-index: 1060;" #template1>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Save Filter</h4>
        <mat-icon class="close" (click)="closeModal()">close</mat-icon>
    </div>
    <div class="modal-body">
        <div class="popupLayout">
            <div class="fullWidth">
                <div *ngIf="popupMessageBody?.length" class="alert alert-success message-block" [ngClass]="{
                    'alert-success': popupMessageTitle == 'Success',
                    'alert-danger': popupMessageTitle == 'Failed',
                    'alert-info': popupMessageTitle == 'Information'
                  }">
                    <button type="button" class="close-icon" (click)="closePopupMessage()">
                        <span class="material-icons">close</span>
                    </button>
                    <strong>{{ popupMessageTitle }}</strong>:
                    <span class="mx-1">{{ popupMessageBody }}</span>
                </div>
                <div *ngIf="ReportMainData.savedReportId > 0" style="padding-top: 10px;">
                    <label>
                        Click on 'Save' to overwrite the existing Saved Filter with same name.
                        <br>
                        Click on 'Save As' to create new Saved Filter with new name.</label>
                </div>
                <div style="padding-top: 10px;">
                    <label>Report Name</label>
                    <mat-form-field appearance="outline">
                        <!-- [ngModelOptions]="{standalone:true}" -->
                        <input type="text" matInput [(ngModel)]="savedReportName">
                    </mat-form-field>
                </div>
                <div style="padding-top: 10px;">
                    <label>Comments</label>
                    <mat-form-field appearance="outline">
                        <textarea matInput cols="30" rows="5" [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="savedReportComments"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="confirmationButtons">
                <button class="deleteBtn" (click)="SaveFilter()">Save</button>
                <span style="padding-left: 10px;"></span>
                <button *ngIf="ReportMainData.savedReportId > 0" class="deleteBtn" (click)="SaveAsFilter()">Save
                    As</button>
            </div>
        </div>
    </div>
</ng-template>